export default ({ fill, className }) => {
  const iconColor = fill || "#000f45";
  const iconClass = className || null;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      className={iconClass}
    >
      <path
        fill={iconColor}
        fill-rule="evenodd"
        d="M19.0505837,0 C15.4811747,0 12.4306229,1.26587518 9.89883268,3.79766537 C7.36704249,6.32945556 6.10116732,9.38000735 6.10116732,12.9494163 C6.10116732,15.979261 7.05576243,18.6977818 8.96498054,21.1050584 L0.435797665,29.6342412 C0.145264441,29.8832697 0,30.2049268 0,30.5992218 C0,30.9935168 0.134888412,31.3255498 0.404669261,31.5953307 C0.674450229,31.8651116 1.00648322,32 1.40077821,32 C1.7950732,32 2.11673032,31.8547356 2.36575875,31.5642023 L10.8949416,23.0350195 C13.3022182,24.9442376 16.020739,25.8988327 19.0505837,25.8988327 C22.6199927,25.8988327 25.6705444,24.6329575 28.2023346,22.1011673 C30.7341248,19.5693771 32,16.5188253 32,12.9494163 C32,9.38000735 30.7341248,6.32945556 28.2023346,3.79766537 C25.6705444,1.26587518 22.6199927,0 19.0505837,0 Z M19,24 C15.95832,24 13.364596,22.927096 11.218752,20.781248 C9.072904,18.635404 8,16.04168 8,13 C8,9.95832 9.072904,7.364596 11.218752,5.218752 C13.364596,3.072904 15.95832,2 19,2 C22.04168,2 24.635404,3.072904 26.781248,5.218752 C28.927096,7.364596 30,9.95832 30,13 C30,16.04168 28.927096,18.635404 26.781248,20.781248 C24.635404,22.927096 22.04168,24 19,24 Z"
        transform="matrix(-1 0 0 1 32 0)"/>
    </svg>
  )
}



// WEBPACK FOOTER //
// ./src/assets/images/search-icon.js